<template>
  <v-dialog :value="dialog" persistent max-width="480" content-class="motivo-cambio">
    <v-card>
      <div class="motivo__encabezado">
        <v-icon color="white" class="mr-2">mdi-lock-outline</v-icon>
        <span class="motivo__titulo">{{ titulo }}</span>
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="$emit('cancelar')" title="Cerrar"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-card-text class="pt-4">
        <div class="motivo__detalle" v-if="detalle">{{ detalle }}</div>
        <p class="motivo__ayuda">Esta línea ya se guardó o se imprimió. Para cambiarla escribe el motivo: queda registrado con tu usuario y la hora.</p>
        <div class="motivo__opciones">
          <v-chip v-for="o in opciones" :key="o" small outlined color="primary" @click="motivo = o">{{ o }}</v-chip>
        </div>
        <ng-text-keyboard :filled="false" :dense="true" v-model="motivo" label="Motivo" hide-details autofocus class="mt-3"></ng-text-keyboard>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-4 py-3">
        <v-btn text large @click="$emit('cancelar')">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed large color="primary" :disabled="!valido" @click="confirmar">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MotivoDeCambio",
  props: {
    dialog: { type: Boolean, default: false },
    titulo: { type: String, default: "Motivo del cambio" },
    detalle: { type: String, default: "" },
  },
  data: () => ({
    motivo: "",
    opciones: ["Error al digitar", "El cliente cambió de opinión", "Producto agotado", "Corrección de precio"],
  }),
  computed: {
    valido() {
      return (this.motivo || "").trim().length >= 3;
    },
  },
  watch: {
    dialog(abierto) {
      if (abierto) {
        this.motivo = "";
      }
    },
  },
  methods: {
    confirmar() {
      if (this.valido) {
        this.$emit("confirmar", this.motivo.trim());
      }
    },
  },
};
</script>

<style>
.motivo__encabezado {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}

.motivo__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.motivo__detalle {
  font-weight: 700;
  margin-bottom: 4px;
}

.motivo__ayuda {
  margin: 0 0 10px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.9rem;
}

.motivo__opciones {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>
